import styles from './styles.module.css'
import { Row, Col, Typography } from 'antd'
import { useNavigate } from 'react-router-dom'

import { ReactComponent as CollectionSvg } from '../../../assets/Collections.svg'
import { ReactComponent as PaymentSvg } from '../../../assets/Payment.svg'
import { ReactComponent as UserSvg } from '../../../assets/User.svg'
import { ReactComponent as FundingSvg } from '../../../assets/Funding.svg'
import { ReactComponent as DeductionSvg } from '../../../assets/Deduction.svg'

const { Title } = Typography

type FeatureItem = {
    title: string | JSX.Element
    link: string
    Svg: React.FC<any>
    description: JSX.Element
}

const FeatureList: FeatureItem[] = [
    {
        title: 'Collection',
        Svg: CollectionSvg,
        description: <>Use our simulator to create or update collection easily.</>,
        link: 'collection',
    },
    {
        title: 'User',
        Svg: UserSvg,
        description: <>You can see and update user data using our simulator.</>,
        link: 'user',
    },
    {
        title: 'Payment',
        Svg: PaymentSvg,
        description: <>Update simple payments status using our simulator.</>,
        link: 'simple_payment',
    },
    {
        title: 'Funding',
        Svg: FundingSvg,
        description: <>Create funding to increase user's balance.</>,
        link: 'funding',
    },
    {
        title: 'Deduction',
        Svg: DeductionSvg,
        description: <>Create deduction to reduce user's balance.</>,
        link: 'deduction',
    },
]

function Feature({ title, Svg, description, link }: FeatureItem) {
    // const history = useHistory()
    const navigate = useNavigate()
    const redirect = () => {
        navigate(link)
    }

    return (
        <Col className={styles.card} onClick={redirect}>
            <div className="padding--sm">
                <div className={styles.cardTitleContainer}>
                    <Svg className={styles.featureSvg} role="img" />
                    {/* <Svg /> */}
                    <Title level={4} className="margin--none">
                        {title}
                    </Title>
                </div>
                <p style={{ maxWidth: '80%' }}>{description}</p>
            </div>
        </Col>
    )
}

export default function HomepageFeatures(): JSX.Element {
    return (
        <section>
            <div>
                <Title level={3} id="featured">
                    Featured Simulators
                </Title>
                <div className="container">
                    <Row className={styles.featuredContainer} justify="start">
                        {FeatureList.map((props, idx) => (
                            <Feature key={idx} {...props} />
                        ))}
                    </Row>
                </div>
            </div>
        </section>
    )
}
